import { TabsLayout } from "#layouts";

export const PbmPortalPatient = () => (
	<TabsLayout
		entity="patient"
		basePath="/pbm-portal/patient"
		paramName="patientID"
		scope="pbm-portal-patient"
	/>
);
